import { useState } from "react";
import "./product-gallery.css";

function fileUrl(fileId) {
    return `/api/v1/files/${fileId}`;
}

export default function ProductImageGallery({ photoIds = [], title, placeholder, className = "" }) {
    const images = photoIds?.length ? photoIds : [];
    const [selectedIndex, setSelectedIndex] = useState(0);
    const safeIndex = images.length ? Math.min(selectedIndex, images.length - 1) : 0;
    const activePhotoId = images[safeIndex];

    if (!images.length) {
        return (
            <div className={`product-gallery${className ? ` ${className}` : ""}`}>
                <div className="product-gallery-main">
                    <div className="placeholder-image">{placeholder || "P"}</div>
                </div>
            </div>
        );
    }

    return (
        <div className={`product-gallery${className ? ` ${className}` : ""}`}>
            <div className="product-gallery-main">
                <img src={fileUrl(activePhotoId)} alt={title} />
            </div>
            {images.length > 1 && (
                <div className="product-gallery-thumbs" role="listbox" aria-label="Images du produit">
                    {images.map((photoId, index) => (
                        <button
                            key={photoId}
                            type="button"
                            role="option"
                            aria-selected={index === safeIndex}
                            className={`product-gallery-thumb${index === safeIndex ? " is-active" : ""}`}
                            onClick={() => setSelectedIndex(index)}
                        >
                            <img src={fileUrl(photoId)} alt={`${title} — image ${index + 1}`} />
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
}
